import { CONTEXT_MENU_EVENTS, CONTEXT_MENU_ITEMS } from "Common/Constants";
import { IContextMenuItem } from "Common/Interfaces";

export const GenerateContextMenuItems = (menuItems: CONTEXT_MENU_EVENTS[]): IContextMenuItem[] => {
  const itemOrderMapping: Partial<Record<CONTEXT_MENU_EVENTS, number>> = {};
  menuItems.forEach((item, index) => {
    itemOrderMapping[item] = index;
  });

  const filteredAndSortedItems = CONTEXT_MENU_ITEMS.filter((item) => menuItems.includes(item.event)).sort((a, b) => {
    const orderA = itemOrderMapping[a.event] ?? 0;
    const orderB = itemOrderMapping[b.event] ?? 0;
    return orderA - orderB;
  });

  return filteredAndSortedItems;
};
